import React from 'react';
import { GraduationCap, Building, Briefcase, FolderOpen } from 'lucide-react';
const audiences = [{
  icon: GraduationCap,
  title: 'Psicopedagogas',
  desc: 'En consultorio privado o clínica'
}, {
  icon: Building,
  title: 'Equipos de orientación',
  desc: 'Escolar y de apoyo institucional'
}, {
  icon: Briefcase,
  title: 'Profesionales itinerantes',
  desc: 'Que trabajan en varias instituciones'
}, {
  icon: FolderOpen,
  title: 'Quienes buscan orden',
  desc: 'Material organizado y aplicable'
}];
export function IdealParaSection() {
  return <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-amber-100/80 via-orange-100/60 to-yellow-100/80 relative overflow-hidden" data-id="element-75">
      <div className="absolute inset-0 opacity-20" data-id="element-76">
        <div className="absolute top-0 right-0 w-72 h-72 bg-orange-300 rounded-full blur-3xl" data-id="element-77" />
        <div className="absolute bottom-0 left-0 w-52 h-52 bg-yellow-300 rounded-full blur-3xl" data-id="element-78" />
      </div>
      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-79">
        <h2 className="text-4xl md:text-5xl font-black mb-4 text-gray-900 uppercase tracking-wide" data-id="element-80">
          Ideal para
        </h2>
        <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-81">
          Psicopedagogas, equipos de orientación, profesionales que trabajan en
          varias instituciones y quienes buscan material organizado y aplicable.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-82">
          {audiences.map((item, i) => <div key={i} className="bg-white/70 backdrop-blur-sm rounded-2xl p-6 border border-orange-200/50 shadow-md" data-id="element-83">
              <div className="bg-orange-500 rounded-xl w-14 h-14 flex items-center justify-center mx-auto mb-4" data-id="element-84">
                <item.icon className="w-7 h-7 text-white" data-id="element-85" />
              </div>
              <h3 className="text-lg font-black text-gray-900 mb-1" data-id="element-86">
                {item.title}
              </h3>
              <p className="text-sm text-gray-600 font-medium" data-id="element-87">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}